import { useForm } from 'react-hook-form';
import { useSiteDetection } from 'shared/hooks';
import { useGetWorkTemplate } from 'api';
import { ProjectFormTypeCreate } from 'shared/components/project-forms/types/project-form.types';
import { ProjectCreateFormPage } from './form/project-create-form-page';

export const ProjectCreateDataProvider = () => {
  const formMethods = useForm<ProjectFormTypeCreate>({ defaultValues: { location: null } });

  const jobId = formMethods.watch('jobId');

  const { site } = useSiteDetection();
  const workTemplateDetailsQuery = useGetWorkTemplate(site, jobId, !!jobId);

  return (
    <ProjectCreateFormPage
      successMessage={`Project aangemaakt`}
      pageTitle={`Maak nieuw project aan`}
      workTemplateDetail={workTemplateDetailsQuery.data}
    />
  );
};
